<template>
  <div id="app">
    <div class="fcc back">
      <div class="fcb w-1200 t66">
        <p>欢迎您来到四川省国新联程物流集团有限公司~~~</p>
        <div class="fcc">
          <a href="https://www.cmjt.com.cn">川煤官网</a>
          <div class="line"></div>
          <a href="http://192.168.1.80/cmoa/" target="_blank">川煤OA</a>
        </div>
      </div>
    </div>
    <div class="fcc back1">
      <div class="fcb w-1200">
        <div class="fcc">
          <img class="mr-63" src="../images/logo.png" @click="toHome"/>
          <div class="fcb w-185">
            <div
              :class="[
                't18',
                selectedIndex === index ? 't5b color' : ''
              ]"
              @click="navTo(item, index)"

              v-for="(item, index) in tabs" :key="index"
            >

              <!-- <router-link :to="item.path">{{item.title}}</router-link> -->
              <!-- <a :href="item.path">{{item.title}}</a> -->
              <span>{{item.title}}</span>
            </div>

          </div>
        </div>
        <div class="fcc">
          <input
            class="input t99"
            type="text"
            placeholder="输入您要搜索的关键字"
            v-model="keywords"
            @keyup.enter="handleSearch"
          />
          <div class="search fcc" @click="handleSearch">
            <img src="../images/research-icon.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getNav } from '@/api';
export default {
  name: "App",
  data() {
    return {
      tabs:[],
      selectedIndex: 0,
      cde:'t5b',
      keywords: ''
    };
  },
  async created() {
    const result = await getNav()
    this.tabs = result.data
  },
  methods: {
    handleSearch() {
      const resolver  = this.$router.resolve({
        path: `/search?keywords=${this.keywords}`
      })
      window.open(resolver.href)
      this.keywords = ''
    },
    toHome() {
      this.selectedIndex = 0
      this.$store.commit('notCurrentPage')
      this.$router.push('/')
    },
    navTo(data, index){
      this.selectedIndex = index;
      this.$store.commit('notCurrentPage')
      if(index === 0) {
        this.$router.push('/')
      }else
        this.$router.push(`/news/${data.type}/${data.colmun_id}`)
    },
    ccc(abc) {
      this.aaa = abc;
    },
  },
};
</script>
<style scoped>
.back {
  height: 32px;
}
.back1 {
  height: 80px;
  background: #ffffff;
}

.line {
  width: 1px;
  height: 12px;
  background: #dbdbdb;
  margin: 0 18px 0 19px;
}
.search {
  width: 44px;
  height: 34px;
  background: #005bac;
}
.input {
  width: 270px;
  height: 34px;
  border: 1px solid #ededed;
  box-sizing: border-box;
  padding-left: 10px;
}
.mr-63 {
  margin-right: 63px;
}
.t18 {
  font-size: 18px;
  box-sizing: border-box;
  padding-bottom: 6px;
}
.w-185 {
  width: 185px;
}
.color {
  border-bottom: 2px solid #005bac;
  border-radius: 1px;
}
</style>
